import React from 'react';
import { Check, AlertCircle, RotateCw } from 'lucide-react';
import { COPY, ARTIFACT_NAMES } from './copy';

// Rows like "✓ Estimated your business value" / "◌ Working out whether
// you'll be OK…" shown while the coach runs tools. A tool that produces a
// card shows a placeholder for it as soon as the tool starts, so the card's
// place in the reply is visible before its figures arrive.
function CardPlaceholder({ kind }) {
  return (
    <div
      data-testid="card-placeholder"
      className="w-full max-w-[420px] rounded-[16px] border border-border bg-card px-4 py-3.5 flex flex-col gap-2.5"
    >
      <span className="font-label text-[10px] uppercase tracking-wide text-muted-foreground">{ARTIFACT_NAMES[kind] || ''}</span>
      <span className="h-5 w-32 rounded-sm bg-muted animate-pulse" />
      <span className="h-3 w-56 rounded-sm bg-muted animate-pulse" />
    </div>
  );
}
export default function ToolProgress({ rows = [], onRetry }) {
  if (!rows.length) return null;
  return (
    <div role="status" aria-live="polite" className="flex flex-col gap-2.5 pl-[42px]">
      {rows.map((row) => (
        <div
          key={row.key}
          className={`flex items-center gap-2.5 flex-wrap text-[13px] leading-[1.4] ${row.state === 'done' ? 'text-muted-foreground' : 'text-foreground'}`}
        >
          <span className="w-4 h-4 flex items-center justify-center shrink-0">
            {row.state === 'done' && <Check size={15} className="text-teal-ink" />}
            {row.state === 'running' && (
              <span className="w-[13px] h-[13px] rounded-full border-2 border-succeedo-orange/25 border-t-succeedo-orange animate-[gb-spin_0.9s_linear_infinite]" />
            )}
            {row.state === 'error' && <AlertCircle size={15} className="text-coral-ink" />}
          </span>
          <span>{row.label}</span>
          {row.artifactKind && row.state !== 'error' && <CardPlaceholder kind={row.artifactKind} />}
          {row.state === 'error' && onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="inline-flex items-center gap-1.5 min-h-9 px-3 rounded-full border border-border bg-transparent text-foreground text-[12px] cursor-pointer"
            >
              <RotateCw size={13} />
              {COPY.retry}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
